import React, { Component } from 'react';
import './Dashboard.scss';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import TabDataDistributor from '../../Containers/TabDataDistributor';
import { bindActionCreators } from 'redux';
import { updateCurrentTabStatus, blockUiFun, updateBotValue, getBotInfo, getSelectedBotData } from '../../Redux/Actions/uiActions';
import copyImage from '../../../assets/icons/ic_file_copy.svg';
import DASHBOAARDBLACKICON from '../../../assets/icons/sideNavIcons/ic_dashboardBlack.png';
import NewPreview from '../NewPreview';
import { loadFonts } from '../../Utils';
import { rlibfn } from 'react-ui-lib';

class Dashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentActiveTabChatbot: 'Preview',
            chatbotTabs: ['Preview', 'Live_Bot', 'Integration_Script'],
            currentIframeSrc: ''
        };
    }

    componentDidUpdate(newProps) {
        const currentDataTemp = newProps.editableBotData.CHATBOT ? newProps.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT : {};
        if (currentDataTemp?.TEXT_INPUT_AREA?.PLACE_HOLDER_COLOR?.VALUE) {
            document.getElementById('ebcss-m') ? document.getElementById('ebcss-m').style.setProperty("--c", currentDataTemp.TEXT_INPUT_AREA.PLACE_HOLDER_COLOR.VALUE) : null;
        }
        if(currentDataTemp?.FONT?.ARRAY && currentDataTemp.FONT.ARRAY.length) {
            loadFonts(currentDataTemp.FONT.ARRAY);
        }
    }

    componentDidMount() {
        this.selectedTab = this.props.location.pathname.split('/')[2];
        let tempArray = this.props.tabListArray.filter(elem => {
            return elem.toLowerCase().replace(/ /g, '').replace(/\//g, '') === this.selectedTab;
        });
        this.props.blockUiFun(true);

        this.props.getBotInfo(this.props.location.pathname.split('/')[1]);
        // this.props.getSelectedBotData(this.props.location.pathname.split('/')[1]);
        
        if (tempArray.length) {
            this.props.updateCurrentTabStatus(this.selectedTab);
            setTimeout(() => {
                if (this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT) {
                    if (this.props.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT.TEXT_INPUT_AREA?.PLACE_HOLDER_COLOR?.VALUE) {
                        document.getElementById('ebcss-m') ? document.getElementById('ebcss-m').style.setProperty("--c", this.props.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT.TEXT_INPUT_AREA.PLACE_HOLDER_COLOR.VALUE) : null;
                    }
                    //do nothing
                } else {
                    // this.props.updateBotValue(this.props.editableBotData);
                }
                this.props.checkNewUpdatedValues();
            }, 500);
        } else if (this.selectedTab === 'settings') {
            this.props.updateCurrentTabStatus(this.selectedTab);
            setTimeout(() => {
                if (this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT) {
                    //do nothing
                } else {
                    // this.props.updateBotValue(this.props.editableBotData);
                }
                this.props.checkNewUpdatedValues();
            }, 500);
        }
        else {
            this.props.blockUiFun(false);
            alert('This is not a valid tab');
        }
    }

    updateCurrentTabStatus = (selectedTab) => {
        let iframeElm = document.getElementById('live_bot_iframe');
        let tempIframeSrc = '';
        let baseUrl = process.env.REACT_APP_HYB_DOMAIN || 'http://127.0.0.1:5001';

        if (selectedTab === 'Live_Bot' && this.state.currentIframeSrc === '') {
            tempIframeSrc = `${baseUrl}/ghost/${this.props.editableBotData?.botId ? this.props.editableBotData.botId : '5cdcf6b4217dda622dd3f869'}`;
        }
        this.setState({ currentActiveTabChatbot: selectedTab, currentIframeSrc: tempIframeSrc });
    }

    createHexValue = (colorcode, alphavalue) => {
        const r = parseInt(colorcode.slice(1, 3), 16);
        const g = parseInt(colorcode.slice(3, 5), 16);
        const b = parseInt(colorcode.slice(5, 7), 16);

        if (alphavalue) {
            return `rgba(${r}, ${g}, ${b}, ${alphavalue / 100})`;
        } else {
            return `rgb(${r}, ${g}, ${b})`;
        }
    }

    copyToClipboard = (str) => {
        const el = document.createElement('textarea');
        el.value = str;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.showFlashMessage(false);
    };

    showFlashMessage = (val) => {
        this.setState({ copyState: !val });
        setTimeout(() => {
            this.setState({ copyState: val });
        }, 2000);
    }

    renderChatHeader = () => {
        let chatTitle = '',chatTitleImg = '';
        let chatHeaderType = this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.CHAT_HEADER?.TITLE_TYPE?.VALUE;
        let chatHeaderStyle = {
            'fontFamily': `${this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.FONT.ARRAY[this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`,
            'color': this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.CHAT_HEADER.FONT_COLOR.VALUE
        };
        if(chatHeaderType === 'Text') {
            chatTitle = this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.CHAT_HEADER?.TITLE_TYPE?.GROUP_TEXT?.TEXT?.VALUE;
            return (
                <h1 aria-hidden="true" style={chatHeaderStyle} className="ebcss-chatbot-name accessibility-js ebcss-animated" title={chatTitle}>{chatTitle}</h1>
            );
        } else if(chatHeaderType === 'Logo') {
            chatTitleImg = this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.CHAT_HEADER?.TITLE_TYPE?.GROUP_LOGO?.LOGO?.VALUE;
            return (
                <img width="100%" height="100%" class="ebcss-client-logo ebcss-animated pe-2" src={chatTitleImg} alt="Chat Header" />
            );
        } else if(chatHeaderType === 'Both' && this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.CHAT_HEADER?.TITLE_TYPE?.GROUP_BOTH?.LOGO_FIRST?.VALUE) {
            chatTitle = this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.CHAT_HEADER?.TITLE_TYPE?.GROUP_BOTH?.TEXT?.VALUE;
            chatTitleImg = this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.CHAT_HEADER?.TITLE_TYPE?.GROUP_BOTH?.LOGO?.VALUE;
            return (
                <>
                    <img width="100%" height="100%" class="ebcss-client-logo ebcss-animated pe-2" src={chatTitleImg} alt="Chat Header" />
                    <h1 aria-hidden="true" style={chatHeaderStyle} className="ebcss-chatbot-name accessibility-js ebcss-animated" title={chatTitle}>{chatTitle}</h1>
                </>
            );
        } else if(chatHeaderType === 'Both') {
            chatTitle = this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.CHAT_HEADER?.TITLE_TYPE?.GROUP_BOTH?.TEXT?.VALUE;
            chatTitleImg = this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.CHAT_HEADER?.TITLE_TYPE?.GROUP_BOTH?.LOGO?.VALUE;
            return (
                <>
                    <h1 aria-hidden="true" style={chatHeaderStyle} className="ebcss-chatbot-name accessibility-js ebcss-animated" title={chatTitle}>{chatTitle}</h1>
                    <img width="100%" height="100%" class="ebcss-client-logo ebcss-animated pe-2" src={chatTitleImg} alt="Chat Header" />
                </>
            );
        }
        chatTitle = this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.CHAT_HEADER?.TEXT?.VALUE;
        return (
            <h1 aria-hidden="true" style={chatHeaderStyle} className="ebcss-chatbot-name accessibility-js ebcss-animated" title={chatTitle}>{chatTitle}</h1>
        );
    }

    render() {
        let buildCount = localStorage.getItem('ebBCL');
        buildCount = parseInt(buildCount);
        buildCount = typeof buildCount === 'number' ? buildCount : 0;
        // let newUi = this.props.editableBotData?.CHATBOT?.CUSTOMISE_YOUR_BOT?.USER_INTERFACE?.New && this.props.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT.USER_INTERFACE.New === true && this.props.isCustomBot ? true : false;
        let baseUrl = process.env.REACT_APP_HYB_DOMAIN || 'http://127.0.0.1:5001';
        if (this.props.editableBotData?.SETTINGS?.SERVER_IP_PORT?.VALUE) {
            baseUrl = this.props.editableBotData.SETTINGS.SERVER_IP_PORT.VALUE
        }
        let BotName = this.props.editableBotData?.SETTINGS?.BOT_NAME?.BOT_NAME?.VALUE && this.props.editableBotData.SETTINGS.BOT_NAME.VALUE.length ? this.props.editableBotData.SETTINGS.BOT_NAME.VALUE : this.props.editableBotData.botId;
        let defaultWithoutJq = `
<!-- Enterprise Bot Chat Resources - START -->
    <script type="text/javascript">
        var currentBotId = '${BotName}';
        var themeColorString = '${this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.THEME_COLOR ? this.props.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT.THEME_COLOR.VALUE : '#3c92cf'}';
        var initMethod = 'default';
    </script>
    <script src="${baseUrl}/dist/${BotName}/chatbot.bundle.js"></script>
<!-- Enterprise Bot Chat Resources - END -->
        `;

        let defaultWithJq = `
<!-- Enterprise Bot Chat Resources - START -->
    <script type="text/javascript">
        var currentBotId = '${BotName}';
        var themeColorString = '${this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.THEME_COLOR ? this.props.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT.THEME_COLOR.VALUE : '#3c92cf'}';
        var initMethod = 'default';
    </script>
    <script src="${baseUrl}/js/jquery.min.js"></script>
    <script src="${baseUrl}/dist/${BotName}/chatbot.bundle.js"></script>
<!-- Enterprise Bot Chat Resources - END -->
        `;

        let iframeWithoutJq = `
<!-- Enterprise Bot Chat Resources - START -->
    <script type="text/javascript">
        var currentBotId = '${BotName}';
    </script>
    <script src="${baseUrl}/dist/${BotName}/ebInitChatWindow.bundle.js"></script>
<!-- Enterprise Bot Chat Resources - END -->
        `;

        if (BotName) {
            defaultWithoutJq = `
<!-- Enterprise Bot Chat Resources - START -->
    <script type="text/javascript">
        var currentBotId = '${BotName}';
        var themeColorString = '${this.props.editableBotData.CHATBOT?.CUSTOMISE_YOUR_BOT?.THEME_COLOR ? this.props.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT.THEME_COLOR.VALUE : '#3c92cf'}';
        var initMethod = 'default';
    </script>
    <script src="${baseUrl}/dist/${BotName}/chatbot.bundle.js"></script>
<!-- Enterprise Bot Chat Resources - END -->
            `;
        }
        let currentData = this.props.editableBotData.CHATBOT ? this.props.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT : {};
        let botChatStyleObj = {}, userChatStyleObj = {}, agentChatStyleObj = {}, suggestionsChatStyleObj = {}, inputChatStyleObj = {}, bodythemeObj = {}, fontStyleObj = {}, textAreaStyleObj = {};

        if (currentData && currentData.THEME_COLOR) {
            botChatStyleObj = {
                'background': currentData.CHAT_BOT_MESSAGE.BACKGROUND_COLOR.VALUE,
                'color': currentData.CHAT_BOT_MESSAGE.FONT_COLOR.VALUE,
                'fontSize': currentData.CHAT_BOT_MESSAGE.FONT_SIZE.VALUE + 'px',
                'boxShadow': `${currentData.CHAT_BOT_MESSAGE.DROP_SHADOW.VALUE[0].VALUE}px ${currentData.CHAT_BOT_MESSAGE.DROP_SHADOW.VALUE[1].VALUE}px ${currentData.CHAT_BOT_MESSAGE.DROP_SHADOW.VALUE[2].VALUE}px ${this.createHexValue(currentData.CHAT_BOT_MESSAGE.DROP_SHADOW.VALUE[3].VALUE, currentData.CHAT_BOT_MESSAGE.DROP_SHADOW.VALUE[4].VALUE)}`,
                'fontFamily': `${currentData.FONT.ARRAY[currentData.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`
            };
            userChatStyleObj = {
                'background': currentData.USER_MESSAGE.BACKGROUND_COLOR.VALUE,
                'color': currentData.USER_MESSAGE.FONT_COLOR.VALUE,
                'fontSize': currentData.USER_MESSAGE.FONT_SIZE.VALUE + 'px',
                'boxShadow': `${currentData.USER_MESSAGE.DROP_SHADOW.VALUE[0].VALUE}px ${currentData.USER_MESSAGE.DROP_SHADOW.VALUE[1].VALUE}px ${currentData.USER_MESSAGE.DROP_SHADOW.VALUE[2].VALUE}px ${this.createHexValue(currentData.USER_MESSAGE.DROP_SHADOW.VALUE[3].VALUE, currentData.USER_MESSAGE.DROP_SHADOW.VALUE[4].VALUE)}`,
                'fontFamily': `${currentData.FONT.ARRAY[currentData.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`
            };
            agentChatStyleObj = {
                'background': currentData.AGENT_MESSAGE.BACKGROUND_COLOR.VALUE,
                'color': currentData.AGENT_MESSAGE.FONT_COLOR.VALUE,
                'fontSize': currentData.AGENT_MESSAGE.FONT_SIZE.VALUE + 'px',
                'boxShadow': `${currentData.AGENT_MESSAGE.DROP_SHADOW.VALUE[0].VALUE}px ${currentData.AGENT_MESSAGE.DROP_SHADOW.VALUE[1].VALUE}px ${currentData.AGENT_MESSAGE.DROP_SHADOW.VALUE[2].VALUE}px ${this.createHexValue(currentData.AGENT_MESSAGE.DROP_SHADOW.VALUE[3].VALUE, currentData.AGENT_MESSAGE.DROP_SHADOW.VALUE[4].VALUE)}`,
                'fontFamily': `${currentData.FONT.ARRAY[currentData.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`
            };
            suggestionsChatStyleObj = {
                'background': currentData.SUGGESTIONS.BACKGROUND_COLOR.VALUE,
                'color': currentData.SUGGESTIONS.FONT_COLOR.VALUE,
                'fontSize': currentData.SUGGESTIONS.FONT_SIZE.VALUE + 'px',
                'boxShadow': `${currentData.SUGGESTIONS.DROP_SHADOW.VALUE[0].VALUE}px ${currentData.SUGGESTIONS.DROP_SHADOW.VALUE[1].VALUE}px ${currentData.SUGGESTIONS.DROP_SHADOW.VALUE[2].VALUE}px ${this.createHexValue(currentData.SUGGESTIONS.DROP_SHADOW.VALUE[3].VALUE, currentData.SUGGESTIONS.DROP_SHADOW.VALUE[4].VALUE)}`,
                'fontFamily': `${currentData.FONT.ARRAY[currentData.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`
            };
            inputChatStyleObj = {
                'background': currentData.TEXT_INPUT_AREA.BACKGROUND_COLOR.VALUE,
                'color': currentData.TEXT_INPUT_AREA.FONT_COLOR.VALUE,
                'fontSize': currentData.TEXT_INPUT_AREA.FONT_SIZE.VALUE + 'px',
                'boxShadow': `${currentData.TEXT_INPUT_AREA.DROP_SHADOW.VALUE[0].VALUE}px ${currentData.TEXT_INPUT_AREA.DROP_SHADOW.VALUE[1].VALUE}px ${currentData.TEXT_INPUT_AREA.DROP_SHADOW.VALUE[2].VALUE}px ${this.createHexValue(currentData.TEXT_INPUT_AREA.DROP_SHADOW.VALUE[3].VALUE, currentData.TEXT_INPUT_AREA.DROP_SHADOW.VALUE[4].VALUE)}`,
                'fontFamily': `${currentData.FONT.ARRAY[currentData.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`
            };

            bodythemeObj = {
                'background': currentData.CHAT_WINDOW_BACKGROUND_COLOR.VALUE
            };

            fontStyleObj = {
                'fontFamily': `${currentData.FONT.ARRAY[currentData.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`
            }

            textAreaStyleObj = {
                'fontSize': currentData.TEXT_INPUT_AREA.FONT_SIZE.VALUE,
                'fontFamily': `${currentData.FONT.ARRAY[currentData.FONT.VALUE].NAME}, 'Helvetica Neue', 'Arial', 'Helvetica', 'sans-serif'`
            }
        }

        const { currentLanguage } = this.props;

        return (
            <>
                <div className='tab-title-wrapper'>
                    <div className='tab-title-icon-wrapper'>
                        <img src={DASHBOAARDBLACKICON} name='CustomiseYourBot' width='24px' height='24px' alt='Customise Your Bot' />
                    </div>
                    <span className='tab-title-text' title='Customise Your Bot'>Customise Your Bot</span>
                </div>
                <div className='tab-pane fade active in show tab-section-wrapper-chatbot' id='chatbot' role='tabpanel' aria-labelledby='chatbot-tab'>
                    <div className='tab-section-wrapper'>
                        <TabDataDistributor
                            tempdata={this.props.editableBotData.CHATBOT ? { data: this.props.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT, title: 'CUSTOMISE_YOUR_BOT', parentArray: ['CHATBOT', 'CUSTOMISE_YOUR_BOT'], isGeneric: false } : {}}
                        />
                    </div>
                </div>
                <div className='chatbot-live-section'>
                    <ul className='nav nav-tabs bot-forge-nav' id='chatbotTabs' role='tablist'>
                        {
                            this.state.chatbotTabs.map((elm, i) => {
                                let currentClassName = elm === this.state.currentActiveTabChatbot ? ' active' : '';
                                return (
                                    <li className={'nav-item' + currentClassName} onClick={() => { this.updateCurrentTabStatus(elm) }} key={i}>
                                        <a href={() => false} className={'nav-link' + currentClassName} id={elm + i} data-toggle='pill' role='tab' aria-controls={elm} aria-selected={elm === this.state.currentActiveTabChatbot}>{elm.replace(/_/g, ' ')}</a>
                                        <div className='underline'></div>
                                    </li>
                                );
                            })
                        }
                    </ul>
                    <div className='tab-content'>
                        <div className={'tab-pane fade Preview' + ('Preview' === this.state.currentActiveTabChatbot ? ' show active' : '')} id='Preview' role='tabpanel' aria-labelledby='Preview_tab' dir={currentLanguage === 'ar' ? 'rtl' : 'ltr'}>
                            {
                                // newUi ? 
                                <NewPreview props={this.props.editableBotData?.CHATBOT?.CUSTOMISE_YOUR_BOT} /> 
                                // :
                                // <div className='chat-wrapper-container'>
                                //     <div className='ebcss-header-wrapper' style={{ 'background': currentData?.THEME_COLOR ? currentData.THEME_COLOR.VALUE ? currentData.THEME_COLOR.VALUE : 'transparent' : '' }}>
                                //         <div className='ebcss-client-logo-wrapper'>
                                //             {/* {currentData?.CHAT_HEADER?.TYPE?.TEXT ? <h1 className='ebcss-chatbot-name' title='Chatbot' style={{ 'color': currentData?.CHAT_HEADER ? currentData.CHAT_HEADER.FONT_COLOR.VALUE : '', 'fontFamily': currentData.FONT.ARRAY[currentData.FONT.VALUE].NAME }}>{currentData?.CHAT_HEADER ? currentData.CHAT_HEADER.TEXT.VALUE : 'Chatbot'}</h1> : <img src={currentData?.CHAT_HEADER ? currentData.CHAT_HEADER.LOGO_IMAGE.VALUE : 'Chatbot'} alt='chatbot' />} */}
                                //             {this.renderChatHeader()}
                                //         </div>
                                //     </div>
                                //     <div id='ebcss-main-chat-wrapper' className='ebcss-main-chat-wrapper'>
                                //         <div id='ebcss-chat-area-wrapper' className='ebcss-chat-area-wrapper' style={bodythemeObj}>
                                //             <div id='ebcss-chat-main-wrapper'>
                                //                 <div id='ebcss-chat-area' className='ebcss-chat-area col-lg-12 col-md-12 col-sm-12 col-xs-12'>
                                //                     <div className='ebcss-message-wrapper ebcss-log-wrapper ebcss-bot col-lg-12 col-md-12 col-sm-12'>
                                //                         {
                                //                             currentData?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? 
                                //                                 <div className='ebcss-client-icon' style={{ 'boxShadow': botChatStyleObj.boxShadow }}>
                                //                                     {currentData?.CHAT_BOT_MESSAGE?.ICON?.VALUE && (currentData.CHAT_BOT_MESSAGE.ICON.VALUE.indexOf('http') > -1) ? <img className='ebcss-image' src={currentData?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? currentData.CHAT_BOT_MESSAGE.ICON.VALUE : ''} alt='Bot' /> : <i className={'eb-icons ' + (currentData?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? currentData.CHAT_BOT_MESSAGE.ICON.VALUE : '')} style={{ 'color': `${currentData?.CHAT_BOT_MESSAGE?.ICON_COLOR?.VALUE ? currentData.CHAT_BOT_MESSAGE.ICON_COLOR.VALUE : '#000000'}` }}></i>}
                                //                                 </div>
                                //                             : ''
                                //                         }
                                //                         <span className={'ebcss-message' + (currentData?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? '' : ' has-no-icon')} style={botChatStyleObj}>
                                //                             <div className='ebcss-arrow-left'></div>
                                //                             Hi Sam, I'm Enterprise Bank's virtual assistant. How may I help you?
                                //                         </span>
                                //                     </div>
                                //                     <div id='ebcss-vertical-suggestions' className='ebcss-slider-section-wrapper ebcss-vertical-suggestions'>
                                //                         <div className='ebcss-text-card-wrapper'>
                                //                             <div className='ebcss-text-card-set'>
                                //                                 <div id='ebcss-suggestions' className='ebcss-card-wrapper ebcss-suggestions-wrapper'>
                                //                                     <div title='Apply for credit card' id='suggestion-0' className='ebcss-suggestion-message ebcss-card' data-hidden='true'>
                                //                                         <a href={() => false} style={suggestionsChatStyleObj}>Apply for credit card</a>
                                //                                     </div>
                                //                                     <div title='Types of accounts' id='suggestion-1' className='ebcss-suggestion-message ebcss-card' data-hidden='true'>
                                //                                         <a href={() => false} style={suggestionsChatStyleObj}>Types of accounts</a>
                                //                                     </div>
                                //                                     <div title='Types of insurance' id='suggestion-2' className='ebcss-suggestion-message ebcss-card' data-hidden='true'>
                                //                                         <a href={() => false} style={suggestionsChatStyleObj}>Types of insurance</a>
                                //                                     </div>
                                //                                 </div>
                                //                             </div>
                                //                         </div>
                                //                     </div>
                                //                     <div className='ebcss-message-wrapper ebcss-log-wrapper ebcss-user col-lg-12 col-md-12 col-sm-12'>
                                //                         <span className={'ebcss-message' + (currentData?.USER_MESSAGE?.ICON?.VALUE ? '' : ' has-no-icon')}  style={userChatStyleObj}>
                                //                             <div className='ebcss-arrow-right'></div>
                                //                             I lost my card
                                //                         </span>
                                //                         {
                                //                             currentData?.USER_MESSAGE?.ICON?.VALUE ?
                                //                                 <div className='ebcss-user-icon' style={{ 'boxShadow': userChatStyleObj.boxShadow }}>
                                //                                     {currentData?.USER_MESSAGE?.ICON?.VALUE && (currentData.USER_MESSAGE.ICON.VALUE.indexOf('http') > -1) ? <img className='ebcss-image' src={currentData?.USER_MESSAGE?.ICON?.VALUE ? currentData.USER_MESSAGE.ICON.VALUE : ''} alt='User' /> : <i className={'eb-icons ' + (currentData?.USER_MESSAGE?.ICON?.VALUE ? currentData.USER_MESSAGE.ICON.VALUE : '')} style={{ 'color': `${currentData?.USER_MESSAGE?.ICON_COLOR?.VALUE ? currentData.USER_MESSAGE.ICON_COLOR.VALUE : '#000000'}` }}></i>}
                                //                                 </div>
                                //                             : ''
                                //                         }
                                //                     </div>
                                //                     <div className='ebcss-message-wrapper ebcss-log-wrapper ebcss-bot col-lg-12 col-md-12 col-sm-12'>
                                //                         {
                                //                             currentData?.CHAT_BOT_MESSAGE?.ICON?.VALUE ?
                                //                                 <div className='ebcss-client-icon' style={{ 'boxShadow': botChatStyleObj.boxShadow }}>
                                //                                     {currentData?.CHAT_BOT_MESSAGE?.ICON?.VALUE && (currentData.CHAT_BOT_MESSAGE.ICON.VALUE.indexOf('http') > -1) ? <img className='ebcss-image' src={currentData?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? currentData.CHAT_BOT_MESSAGE.ICON.VALUE : ''} alt='Bot' /> : <i className={'eb-icons ' + (currentData?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? currentData.CHAT_BOT_MESSAGE.ICON.VALUE : '')} style={{ 'color': `${currentData?.CHAT_BOT_MESSAGE?.ICON_COLOR?.VALUE ? currentData.CHAT_BOT_MESSAGE.ICON_COLOR.VALUE : '#000000'}` }}></i>}
                                //                                 </div>
                                //                             : ''
                                //                         }
                                //                         <span className={'ebcss-message' + (currentData?.CHAT_BOT_MESSAGE?.ICON?.VALUE ? '' : ' has-no-icon')} style={botChatStyleObj}>
                                //                             <div className='ebcss-arrow-left'></div>
                                //                             Sorry I did not understand that, could you please rephrase the question
                                //                         </span>
                                //                     </div>
                                //                     <div className='ebcss-message-wrapper ebcss-notification col-lg-12 col-md-12 col-sm-12'>
                                //                         <span style={fontStyleObj} className='ebcss-message'>Agent has joined this conversation.</span>
                                //                         <span className='ebcss-horizontal-line'></span>
                                //                     </div>
                                //                     <div className='ebcss-message-wrapper ebcss-log-wrapper ebcss-agent col-lg-12 col-md-12 col-sm-12'>
                                //                         {
                                //                             currentData?.AGENT_MESSAGE?.ICON?.VALUE ?
                                //                                 <div className='ebcss-client-icon' style={{ 'boxShadow': agentChatStyleObj.boxShadow }}>
                                //                                     {currentData?.AGENT_MESSAGE?.ICON?.VALUE && (currentData.AGENT_MESSAGE.ICON.VALUE.indexOf('http') > -1) ? <img className='ebcss-image' src={currentData?.AGENT_MESSAGE?.ICON?.VALUE ? currentData.AGENT_MESSAGE.ICON.VALUE : ''} alt='Agent' /> : <i className={'eb-icons ' + (currentData?.AGENT_MESSAGE?.ICON?.VALUE ? currentData.AGENT_MESSAGE.ICON.VALUE : '')} style={{ 'color': `${currentData?.AGENT_MESSAGE?.ICON_COLOR?.VALUE ? currentData.AGENT_MESSAGE.ICON_COLOR.VALUE : '#000000'}` }}></i>}
                                //                                 </div>
                                //                             : ''
                                //                         }
                                //                         <span className={'ebcss-message' + (currentData?.AGENT_MESSAGE?.ICON?.VALUE ? '' : ' has-no-icon')} style={agentChatStyleObj}>
                                //                             <div className='ebcss-arrow-left'></div>
                                //                             <p style={{ ...fontStyleObj, 'font-size': 'inherit' }}>Hi! My name is Sam. How may I help you today?</p>
                                //                         </span>
                                //                     </div>
                                //                 </div>
                                //             </div>
                                //         </div>
                                //         <div className='ebcss-messenger-footer'>
                                //             <div className='ebcss-text-input-wrapper col-lg-12 col-md-12 col-sm-12 col-xs-12' style={inputChatStyleObj}>
                                //                 <form id='ebcss-messageForm' action=''>
                                //                     <input type='hidden' id='ebcss-user' value='' />
                                //                     <textarea style={textAreaStyleObj} id='ebcss-m' className='ebcss-text-input-box' type='text' autoComplete='off' placeholder='Type or click on the microphone'></textarea>
                                //                     <button className='ebcss-send-button' type='submit' disabled id='ebcss-button' value='Send'>
                                //                         {currentData?.TEXT_INPUT_AREA?.SEND_ICON?.VALUE && (currentData.TEXT_INPUT_AREA.SEND_ICON.VALUE.indexOf('http') > -1) ? <img className='ebcss-image ebcss-glyphicon-send' src={currentData?.TEXT_INPUT_AREA?.SEND_ICON?.VALUE ? currentData.TEXT_INPUT_AREA.SEND_ICON.VALUE : ''} alt='Agent' /> : <i className={'eb-icons ebcss-glyphicon-send ' + (currentData?.TEXT_INPUT_AREA?.SEND_ICON?.VALUE ? currentData.TEXT_INPUT_AREA.SEND_ICON.VALUE : '')} style={{ 'color': `${currentData?.TEXT_INPUT_AREA?.SEND_ICON_COLOR?.VALUE ? currentData.TEXT_INPUT_AREA.SEND_ICON_COLOR.VALUE : '#000000'}` }}></i>}
                                //                     </button>
                                //                 </form>
                                //             </div>
                                //         </div>
                                //     </div>
                                // </div>
                            }
                        </div>
                        <div className={'tab-pane fade Live_Bot' + ('Live_Bot' === this.state.currentActiveTabChatbot ? ' show active' : '')} id='Live_Bot' role='tabpanel' aria-labelledby='Live_Bot_tab'>
                            {
                                buildCount > 0 ? <iframe id="live_bot_iframe" src={this.state.currentIframeSrc} title='livebot'></iframe> : <div className='no-iframe-message'>You need to publish the bot once to check 'Live Bot' view</div>
                            }
                        </div>
                        <div className={'tab-pane fade Integration_Script' + ('Integration_Script' === this.state.currentActiveTabChatbot ? ' show active' : '')} id='Integration_Script' role='tabpanel' aria-labelledby='Integration_Script_tab'>
                            <div className='embade-code-container'>
                                <div className={'flash-message-for-copy' + (this.state.copyState ? ' show' : '')}>Script Copid !!</div>
                                <div className='embade-code-container-default'>
                                    <div className='emabde-code-conatiner-header'>
                                        <h4>Default</h4>
                                    </div>
                                    <div className='embade-code-container-body'>
                                        <div className='embade-code-container-body-header'>
                                            <div className='embade-code-container-body-title'>
                                                <h3>Without jQuery:</h3>
                                            </div>
                                            <div className='embade-code-container-body-buttons'>
                                                <span className='embade-code-container-info' title='Default script without jQuery'></span>
                                                <span className='embade-code-container-copy-button'>
                                                    <img src={copyImage} alt='copy' title='Copy' onClick={() => { rlibfn.copyText(iframeScript, rlibfn.showFlashMessage({message: defaultWithoutJq, type: 'success'})) }} />
                                                </span>
                                            </div>
                                        </div>
                                        <div className='embade-code-container-body-code'>
                                            <pre className='embade-code-container-body-code-container'>
                                                {defaultWithoutJq}
                                            </pre>
                                        </div>
                                        <div className='embade-code-container-body-separator'></div>
                                        <div className='embade-code-container-body-header'>
                                            <div className='embade-code-container-body-title'>
                                                <h3>With jQuery:</h3>
                                            </div>
                                            <div className='embade-code-container-body-buttons'>
                                                <span className='embade-code-container-info' title='Default script with jQuery'></span>
                                                <span className='embade-code-container-copy-button'>
                                                    <img src={copyImage} alt='copy' title='Copy' onClick={() => { rlibfn.copyText(iframeScript, rlibfn.showFlashMessage({message: defaultWithJq, type: 'success'})) }} />
                                                </span>
                                            </div>
                                        </div>
                                        <div className='embade-code-container-body-code'>
                                            <pre className='embade-code-container-body-code-container'>
                                                {defaultWithJq}
                                            </pre>
                                        </div>
                                    </div>
                                </div>
                                <div className='embade-code-container-default'>
                                    <div className='emabde-code-conatiner-header'>
                                        <h4>Iframe</h4>
                                    </div>
                                    <div className='embade-code-container-body'>
                                        <div className='embade-code-container-body-header'>
                                            <div className='embade-code-container-body-title'>
                                                {/* <h3>Without jQuery:</h3> */}
                                            </div>
                                            <div className='embade-code-container-body-buttons'>
                                                <span className='embade-code-container-info' title='Iframe script without jQuery'></span>
                                                <span className='embade-code-container-copy-button'>
                                                    <img src={copyImage} alt='copy' title='Copy' onClick={() => { rlibfn.copyText(iframeScript, rlibfn.showFlashMessage({message: iframeWithoutJq, type: 'success'})) }} />
                                                </span>
                                            </div>
                                        </div>
                                        <div className='embade-code-container-body-code'>
                                            <pre className='embade-code-container-body-code-container'>
                                                {iframeWithoutJq}
                                            </pre>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        tabListArray: state.UiReducer && state.UiReducer.tabListArray && state.UiReducer.tabListArray.length ? state.UiReducer.tabListArray : [],
        selectedBotData: state.UiReducer && state.UiReducer.selectedBotData ? state.UiReducer.selectedBotData : false,
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : false,
        currentActiveTab: state.UiReducer && state.UiReducer.currentActiveTab ? state.UiReducer.currentActiveTab : 'chatbot',
        currentLanguage: state.UiReducer && state.UiReducer.currentLanguage ? state.UiReducer.currentLanguage : 'en',
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : [],
        isCustomBot: state.UiReducer && state.UiReducer.isCustomBot ? state.UiReducer.isCustomBot : false
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateCurrentTabStatus,
        blockUiFun,
        updateBotValue,
        getBotInfo,
        getSelectedBotData
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));